/** @jsx jsx */
import { PropsWithChildren } from 'react';
import { css, jsx } from '@emotion/core';

const styleRoot = css`
  box-shadow: 0 4px 12px 0 rgb(0 0 0 / 20%);
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  padding: 56.25% 0 0 0;

  /* Nasty hack to round the edges of the play button. Sorry! */
  & [id$='.big_play_button_background'] {
    border-radius: 20px !important;
  }
`;

const styleChildren = css`
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

function Wrapper({ children }: PropsWithChildren<{}>) {
  return (
    <div css={styleRoot}>
      <div css={styleChildren}>{children}</div>
    </div>
  );
}

export default Wrapper;
